export const SERVICEREQUSETFROMCUSTOMER_GET="SERVICEREQUSETFROMCUSTOMER_GET"
export const SERVICEREQUSETFROMCUSTOMER_SUCCESS="SERVICEREQUSETFROMCUSTOMER_SUCCESS"

export const SERVICEREQUESTDEALERTOCUSTOMER_GET="SERVICEREQUESTDEALERTOCUSTOMER_GET"
export const SERVICEREQUESTDEALERTOCUSTOMER_SUCCESS="SERVICEREQUESTDEALERTOCUSTOMER_SUCCESS"

export const SERVICECENTRICCUSTOMER_GET="SERVICECENTRICCUSTOMER_GET"
export const SERVICECENTRICCUSTOMER_SUCCESS="SERVICECENTRICCUSTOMER_SUCCESS"